import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = ({ path, connectedStripeId, viewerObj, companyEndpoint }) => {
  return (
    <>
      {/* //*this will be worked on in the near future... */}
      {/* <NavLink exact className="list-group-item list-group-item-action" to={`${path}`}>
        <i className="fas fa-user mx-3" />
        Account Overview
      </NavLink> */}

      <NavLink
        exact
        className="list-group-item list-group-item-action"
        to={`${path}`}
      >
        <i className="fas fa-pen mx-3" />
        Edit Email
      </NavLink>

      <NavLink
        className="list-group-item list-group-item-action"
        to={`${path}/change-password`}
      >
        <i className="fas fa-key mx-3" />
        Change Password
      </NavLink>

      {connectedStripeId && viewerObj?.stripeId && (
        <>
          {viewerObj?.subscription?.id && (
            <NavLink
              className="list-group-item list-group-item-action"
              to={`${path}/subscriptions`}
            >
              <i className="fas fa-credit-card mx-3" />
              Subscription
            </NavLink>
          )}
          <NavLink
            className="list-group-item list-group-item-action"
            to={`${path}/billing`}
          >
            <i className="fas fa-pen mx-3" />
            Billing
          </NavLink>
          <NavLink
            className="list-group-item list-group-item-action"
            to={`${path}/purchases`}
          >
            <i className="fas fa-dollar-sign mx-3" />
            Purchased Content
          </NavLink>
          <NavLink
            className="list-group-item list-group-item-action"
            to={`${path}/invoices`}
          >
            <i className="fa-solid fa-receipt mx-3"></i>
            Receipts
          </NavLink>
          <NavLink
            className="list-group-item list-group-item-action"
            to={`${path}/payment-method`}
          >
            <i className="fas fa-credit-card mx-3" />
            Payment Method
          </NavLink>
        </>
      )}

      <NavLink
        exact
        className="list-group-item list-group-item-action"
        to={`/${companyEndpoint}`}
      >
        <i className="fa-solid fa-house mx-3" />
        Home
      </NavLink>
    </>
  );
};

export default Navbar;
